import { createI18n } from 'vue-i18n'

import en from './locale/en.json'
import nl from './locale/nl.json'

const instance = createI18n({
    legacy: false,
    locale: document.documentElement.lang ?? 'nl',
    fallbackLocale: 'en',
    messages: {
        en: en,
        nl: nl,
    },
    globalInjection: true,
})

export default instance
